import { MakeCall } from '../createMakeCall';

const publishUnitType = (makeCall: MakeCall) => (unitTypeId: number) =>
  makeCall<undefined>('PUT', `/api/v2/unit-type/${unitTypeId}/publish`);

export { publishUnitType };
